import React from 'react';
import { Link } from 'react-router-dom';

interface EmptyStateAction {
  label: string;
  to?: string;
  onClick?: () => void;
  icon?: string;
}

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: EmptyStateAction;
  variant?: 'default' | 'compact';
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  variant = 'default',
  className = '',
}) => {
  if (variant === 'compact') {
    return (
      <tr>
        <td colSpan={99} className="text-center text-muted py-4">
          {icon && <i className={`fa ${icon} me-2`}></i>}
          {title}
          {action && (
            <>
              {' '}
              {action.to ? (
                <Link to={action.to} className="btn btn-sm btn-outline-primary ms-2">
                  {action.icon && <i className={`fa ${action.icon} me-1`}></i>}
                  {action.label}
                </Link>
              ) : (
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary ms-2"
                  onClick={action.onClick}
                >
                  {action.icon && <i className={`fa ${action.icon} me-1`}></i>}
                  {action.label}
                </button>
              )}
            </>
          )}
        </td>
      </tr>
    );
  }

  return (
    <div className={`text-center py-5 ${className}`}>
      {icon && (
        <i className={`fa ${icon} fa-3x text-muted mb-3 d-block`}></i>
      )}
      <h5 className="text-muted mb-1">{title}</h5>
      {description && (
        <p className="text-muted mb-3 small">{description}</p>
      )}
      {action && (
        action.to ? (
          <Link to={action.to} className="btn btn-primary btn-sm">
            {action.icon && <i className={`fa ${action.icon} me-1`}></i>}
            {action.label}
          </Link>
        ) : (
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={action.onClick}
          >
            {action.icon && <i className={`fa ${action.icon} me-1`}></i>}
            {action.label}
          </button>
        )
      )}
    </div>
  );
};

export default EmptyState;
